module.exports = __webpack_public_path__ + "img/champu vaginal.8910f0a1.png";